{
  "id": "001-001",
  "title": "Forming connections",
  "layout": {
    "offset": "odd-row",
    "tiles": {
      "0": {
        "0": {
          "id": "98c1b870",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 0
                },
                {
                  "color": "#0000ff",
                  "direction": 1
                },
                {
                  "color": "#0000ff",
                  "direction": 2
                },
                {
                  "color": "#0000ff",
                  "direction": 3
                },
                {
                  "color": "#0000ff",
                  "direction": 4
                },
                {
                  "color": "#0000ff",
                  "direction": 5
                }
              ],
              "id": "11ea04e4"
            }
          ]
        },
        "1": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 4
                },
                {
                  "color": "#0000ff",
                  "direction": 0
                },
                {
                  "color": "#0000ff",
                  "direction": 5
                }
              ],
              "id": "96eb1c1b"
            }
          ],
          "id": "f7b48b08"
        },
        "-1": {
          "id": "a7f644b8",
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 1
                },
                {
                  "color": "#0000ff",
                  "direction": 3
                },
                {
                  "color": "#0000ff",
                  "direction": 2
                }
              ],
              "id": "e322950f"
            }
          ]
        }
      },
      "1": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 5
                },
                {
                  "color": "#0000ff",
                  "direction": 1
                },
                {
                  "color": "#0000ff",
                  "direction": 0
                }
              ],
              "id": "5405af42"
            }
          ],
          "id": "8f2cda31"
        },
        "-1": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 0
                },
                {
                  "color": "#0000ff",
                  "direction": 2
                },
                {
                  "color": "#0000ff",
                  "direction": 1
                }
              ],
              "id": "176953c3"
            }
          ],
          "id": "57bb0429"
        }
      },
      "-1": {
        "0": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 3
                },
                {
                  "color": "#0000ff",
                  "direction": 5
                },
                {
                  "color": "#0000ff",
                  "direction": 4
                }
              ],
              "id": "bcf89ade"
            }
          ],
          "id": "2eb11c84"
        },
        "-1": {
          "type": "tile",
          "items": [
            {
              "type": "terminus",
              "openings": [
                {
                  "color": "#0000ff",
                  "direction": 2
                },
                {
                  "color": "#0000ff",
                  "direction": 4
                },
                {
                  "color": "#0000ff",
                  "direction": 3
                }
              ],
              "id": "cdf38c3f"
            }
          ],
          "id": "e2e2cc4d"
        }
      }
    },
    "modifiers": [
      {
        "type": "toggle",
        "id": "99243a1a"
      }
    ]
  },
  "version": 2,
  "requirements": [
    {
      "type": "connections",
      "amount": 5
    },
    {
      "type": "moves",
      "amount": 3
    }
  ]
}
